<div>
  <div
    class="warning-message flex"
    *ngIf="batchChanges.length && !breakingChanges.length"
  >
    <div
      class="background-yellow flex justify-start items-center p-4 pl-8 w-full"
    >
      <div class="flex items-center banner-big-text-container">
        <mat-icon class="warning-image mr-3 text-error-red">
          sync_problem
        </mat-icon>
        <span
          class="text-bold text-18"
          data-automation="results-not-updated-text"
        >
          {{ 'scenario.results.not_updated' | translate }}
        </span>
      </div>
      <div class="border-left">
        <span data-automation="results-have-changed-text">
          {{ 'scenario.results.underlying_data_changed' | translate }}
        </span>
        <br />
        <div class="programs-list">
          Programs affected:
          <span class="programs-list-item" *ngFor="let change of batchChanges">
            {{ change.newValue }}
            <span class="programs-list-item-timestamp">
              (Updated: {{ change.timestamp | date: 'longDate' }})
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
